module.exports = __webpack_public_path__ + "/login_ui/img/dk-6c44836d194ca52d89ffe0227429a328.svg";